import { render } from "./CamaraShow.vue?vue&type=template&id=46a48adf&scoped=true"
import script from "./CamaraShow.vue?vue&type=script&lang=js"
export * from "./CamaraShow.vue?vue&type=script&lang=js"

import "./CamaraShow.vue?vue&type=style&index=0&id=46a48adf&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a48adf"]])

export default __exports__